import React, { FC, useMemo, useState } from 'react';
import { FaBullhorn, FaCreditCard, FaRegFileAlt } from 'react-icons/fa';
import { TabItem, Tabs } from '@/lib';
import { CampaignsInnerRoutePlaceholderV2 } from './CampaignsInnerRoutePlaceholderV2';

const SMS_CAMPAIGNS_TAB = 'campaign:whatsappWorkspace.campaigns' as const;
const SMS_TEMPLATES_TAB = 'campaign:whatsappWorkspace.templates' as const;
const SMS_PACKAGES_TAB = 'campaign:whatsappWorkspace.packages' as const;

export const CampaignsSmsWorkspaceV2: FC = () => {
  const tabItems = useMemo<TabItem[]>(
    () => [
      {
        id: 'campaigns',
        title: SMS_CAMPAIGNS_TAB,
        icon: <FaBullhorn className='size-4' />,
        count: 'N/A',
        element: <CampaignsInnerRoutePlaceholderV2 title='SMS campaigns' description='SMS campaigns workspace will be available soon.' />,
      },
      {
        id: 'templates',
        title: SMS_TEMPLATES_TAB,
        icon: <FaRegFileAlt className='size-4' />,
        count: 'N/A',
        element: <CampaignsInnerRoutePlaceholderV2 title='SMS templates' description='SMS templates workspace will be available soon.' />,
      },
      {
        id: 'packages',
        title: SMS_PACKAGES_TAB,
        icon: <FaCreditCard className='size-4' />,
        count: 'N/A',
        element: <CampaignsInnerRoutePlaceholderV2 title='SMS packages' description='SMS package management will be available soon.' />,
      },
    ],
    []
  );
  const [currentTabTitle, setCurrentTabTitle] = useState(tabItems[0].title);
  const currentTab = tabItems.find((item) => item.title === currentTabTitle) ?? tabItems[0];

  const handleSelectTab = (tabItem: TabItem) => {
    setCurrentTabTitle(tabItem.title);
  };

  return <Tabs items={tabItems} currentTab={currentTab.title} onSelectTab={handleSelectTab} />;
};
